import React from "react";
import { HStack, StackProps } from "../Stack/Stack";

const Circle = ({
  color,
  percentage,
  radius,
  strokeWidth,
}: {
  color?: string;
  percentage?: number;
  radius: number;
  strokeWidth: number;
}) => {
  const circ = 2 * Math.PI * radius;
  const strokePct = ((100 - percentage) * circ) / 100; // progress starting point(from 0% to 100%)
  return (
    <circle
      r={radius}
      cx={radius + strokeWidth}
      cy={radius + strokeWidth}
      fill="transparent"
      stroke={strokePct !== circ ? color : ""}
      strokeWidth={strokeWidth}
      strokeDasharray={circ}
      strokeDashoffset={percentage ? strokePct : 0}
    ></circle>
  );
};

const Text = ({
  percentage,
  radius,
}: {
  percentage?: number;
  radius: number;
}) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      fontSize={`${radius / 2}px`}
    >
      {percentage.toFixed(0)}%
    </text>
  );
};

interface IProgressCircleProps extends StackProps {
  progress: string | number;
  size?: string;
  strokeWidth?: string;
}

export const ProgressCircle = (props: IProgressCircleProps) => {
  const { progress, size = "2rem", strokeWidth = "0.2rem", ...rest } = props;
  const numericSize = parseFloat(size) * 16; // Convert rem to pixels
  const numericStrokeWidth = parseFloat(strokeWidth) * 16; // Convert rem to pixels
  const radius = numericSize / 2 - numericStrokeWidth; // Adjust radius based on size and stroke width
  return (
    <HStack {...rest}>
      <svg width={numericSize} height={numericSize}>
        <g
          transform={`rotate(-90 ${radius + numericStrokeWidth} ${
            radius + numericStrokeWidth
          })`}
        >
          <Circle
            color="#999999"
            radius={radius}
            strokeWidth={numericStrokeWidth}
          />
          <Circle
            color="white"
            percentage={Number(progress)}
            radius={radius}
            strokeWidth={numericStrokeWidth}
          />
        </g>
        <Text percentage={Number(progress)} radius={radius} />
      </svg>
    </HStack>
  );
};
